import React from 'react';
import { Toggle } from '@cimpress/react-components';

interface FullWrapProps {
    fullWrapEnabled?: boolean;
    id?: string;
    onToggle: (id: string) => void;
}

const FullWrap: React.FC<FullWrapProps> = ({ fullWrapEnabled, id, onToggle }) => {
    return (
        <div className='full-wrap' data-testid='transform-fullwrap-wrapper'>
            Full Wrap
            <Toggle on={fullWrapEnabled} onClick={() => onToggle(id!)} />
        </div>
    );
};

export default React.memo(FullWrap);
